import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Alert from '@mui/material/Alert';
import locationFeatureFlagService from '../../services/locationFeatureFlagService';

const FeatureFlag = ({ name, action, warningMessage }) => {
  const [status, setStatus] = useState({ blocked: false, dismissed: false, warningMessage: '' });

  useEffect(() => {
    let isActive = true;

    if (action !== undefined) {
      setStatus({
        blocked: action === 'deny',
        dismissed: false,
        warningMessage: action === 'deny' ? warningMessage ?? '' : '',
      });
      return () => {
        isActive = false;
      };
    }

    setStatus({ blocked: false, dismissed: false, warningMessage: '' });
    locationFeatureFlagService
      .lookupLocationFeatureFlag({ featureFlag: name })
      .then(({ data }) => {
        if (isActive) {
          const blocked = data?.action === 'deny';
          setStatus({
            blocked,
            dismissed: false,
            warningMessage: blocked ? data?.warningMessage ?? '' : '',
          });
        }
      })
      .catch((error) => {
        console.error(`Could not verify ${name} feature availability.`, error);
      });

    return () => {
      isActive = false;
    };
  }, [name, action, warningMessage]);

  if (!status.blocked || status.dismissed) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      onClose={() => setStatus((currentStatus) => ({ ...currentStatus, dismissed: true }))}
      sx={{ mb: 2 }}
    >
      {status.warningMessage || `The ${name} feature is blocked for this location.`}
    </Alert>
  );
};

FeatureFlag.propTypes = {
  name: PropTypes.string.isRequired,
  action: PropTypes.oneOf(['allow', 'deny', null]),
  warningMessage: PropTypes.string,
};

export default FeatureFlag;
